import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'PATCH_PTM_END_CLASS_FEEDBACK',
  PATCH_SUCCESS: 'PATCH_PTM_END_CLASS_FEEDBACK_SUCCESS',
  PATCH_FAILURE: 'PATCH_PTM_END_CLASS_FEEDBACK_FAILURE',
};

export const patch = actions.patch(ptmId => `${BASE_URL}/ptm/${ptmId}/`, {
  PENDING: ACTIONS.PATCH,
  SUCCESS: ACTIONS.PATCH_SUCCESS,
  FAILURE: ACTIONS.PATCH_FAILURE,
});
